import getFuncByMode from '../../utils/getFuncByMode';

import chuck from './chuck';
import mandi from './mandi';

export default itemId => getFuncByMode({
  chuck,
  mandi,
})(itemId);
